import React from "react";

import {
  FormEnabler,
  ValidatedForm,
  MInput,
  MToggle,
  MTextArea,
  MFile,
  MLabel,
  MSelect,
} from "components/forms";

import {
  payloadBuilder,
  invalidFieldsMapper,
  networkErrorHelper,
  notNullObjectBuilder,
  adminService,
} from "libs";

import { Card, CardBody } from "design-react-kit";

export class AdminLessonLiveClassMaterialForm extends ValidatedForm {
  ERROR_MESSAGES = {
    title: "Titolo obbligatorio",
    aa: "Anno Accademico obbligatorio (AAAA)",
    idClass: "Classe obbligatoria",
    idExamSession: "ID Sessione Esame obbligatorio",
  };

  emptyFields = {
    title: "",
    description: "",
    idClass: "",
    visible: false,
    courseCode: "",
    aa: "",
    progress: 0,
    type: "",
    url: "",
    document: this.props.idMaterial,
    note: "",
    idExamSession: "",
    folder: "",
  };

  validation = {
    title: (value) => value.length > 0,
    idClass: (value) => value !== "-1",
    aa: (value) => /^\d{4}$/i.test(value) && value !== null,
    idExamSession: (value) => parseInt(value) >= 0,
  };

  FIELDS_GROUP = [
    [
      {
        id: "aa",
        field: "aa",
        label: "Anno Accademico",
        component: MInput,
        type: "number",
        className: "col-md-2",
      },
      {
        id: "courseCode",
        field: "courseCode",
        label: "Codice Corso",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        id: "visible",
        name: "visible",
        field: "visible",
        label: "Visibile",
        component: MToggle,
        className: "col-md-4",
      },
    ],
    [
      {
        id: "folder",
        field: "folder",
        label: "Cartella",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
      {
        id: "title",
        field: "title",
        label: "Titolo",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
      {
        id: "description",
        field: "description",
        label: "Descrizione",
        component: MTextArea,
        rows: 3,
        className: "col-md-12 mb-4",
      },
    ],
    [
      {
        id: "idExamSession",
        field: "idExamSession",
        label: "ID Sessione Esame",
        component: MInput,
        type: "number",
        className: "col-md-4",
      },
      {
        field: "idClass",
        label: "ID Classe",
        component: MInput,
        type: "number",
        className: "col-md-4",
      },
      {
        id: "progress",
        field: "progress",
        label: "Ordine di Visualizzazione",
        component: MInput,
        type: "number",
        className: "col-md-4",
      },
    ],
    [
      {
        id: "note",
        field: "note",
        label: "Note",
        component: MTextArea,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        label: "Carica materiale didattico",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 my-3 mb-0",
      },
      {
        id: "type",
        field: "type",
        label: "Seleziona tipo di materiale",
        component: MSelect,
        options: [],
        payload: {
          options: [
            { label: "Seleziona tipo di materiale", value: "" },
            { value: "file", label: "File" },
            { value: "url", label: "URL" },
          ],
        },
        className: "col-md-12",
      },
      {
        id: "url",
        field: "url",
        label: "Link materiale",
        component: MInput,
        type: "url",
        className: "col-md-12",
      },
      {
        id: "document",
        field: "document",
        label: "allegati",
        component: MFile,
        config: {
          endPoint: "/admin/lessonlive-class-material-file",
          mandatory: false,
          accept: ".pdf,.doc,.docx,.jpg,.bmp,.jpeg, .pptx",
          fieldName: "document",
          maxFiles: 1,
        },
        className: "col-md-12",
      },
    ],
  ];

  //--- ---
  constructor(props) {
    super(props);

    this.state = {
      ...this.emptyFields,
      defaultValues: { ...this.emptyFields },
      formActive: true,
      idMaterial: this.props.idMaterial,
    };

    // bind event handler to invoke it from child component
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.loadRemote();
  }

  loadRemote(additionalState = {}) {
    //--- prevent loadRemote when not required ---
    if (parseInt(this.props.idMaterial) <= 0) {
      return false;
    }

    adminService
      .loadLessonLiveClassMaterial(this.props.idMaterial)
      .then(({ data }) => {
        const defaultValues = notNullObjectBuilder(this.emptyFields, {
          ...data.payload.lessonLiveClassMaterial,
          document: this.props.idMaterial,
        });

        const newState = {
          defaultValues,
          ...additionalState,
          loading: false,
        };

        this.setState(newState);
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        console.log(error);
        this.setState({ loading: false });
      });
  } //loadremote

  onCancel = () => {
    this.resetForm();
  }; //onCancel

  onBackPage = () => {
    window.history.back();
  };

  saveRemote = () => {
    const payload = payloadBuilder(this.state);

    if (parseInt(this.props.idMaterial) > 0) {
      adminService
        .updateLessonLiveClassMaterial(payload)
        .then((result) => {
          this.onBackPage();
        })
        .catch((errors) => {
          if (networkErrorHelper.is422(errors)) {
            const newState = invalidFieldsMapper(
              errors,
              this.state,
              this.ERROR_MESSAGES
            );
            this.setState({ ...newState });
          } else {
            networkErrorHelper.notify(errors);
          }
        });
    } else {
      adminService
        .insertLessonLiveClassMaterial(payload)
        .then((result) => {
          this.onBackPage();
        })
        .catch((errors) => {
          if (networkErrorHelper.is422(errors)) {
            const newState = invalidFieldsMapper(
              errors,
              this.state,
              this.ERROR_MESSAGES
            );
            this.setState({ ...newState });
          } else {
            networkErrorHelper.notify(errors);
          }
        });
    }
  };

  render() {
    let { formActive, defaultValues, idMaterial } = this.state;
    const { formValid, code } = this.renderFields(
      this.FIELDS_GROUP,
      defaultValues,
      formActive
    );

    return (
      <>
        <Card
          tag="div"
          className="card-bg card-big rounded shadow border-bottom-card"
        >
          <div className="flag-icon" />
          <CardBody tag="div">
            <form className="user" id="promotionalform">
              {code}
            </form>

            <div className="mt-4">
              <FormEnabler
                onSubmit={this.onSubmit}
                onCancel={
                  parseInt(idMaterial) > 0 ? this.onCancel : this.onBackPage
                }
                onToggle={this.toggleForm}
                isFormActive={formActive}
                disableSave={!formValid}
              />
            </div>
          </CardBody>
        </Card>
      </>
    );
  }
}
